import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactMemories = (contactId?: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const queryKey = [contactsEndpoints.memories(contactId ?? '')];

  const { data, status, error } = useQuery({
    queryKey,
    queryFn: () => contactsAPI.listMemories(contactId!),
    enabled: !!contactId,
  });

  const deleteMutation = useMutation({
    mutationFn: (memoryId: string) => contactsAPI.deleteMemory(contactId!, memoryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      toast.error(t('contacts.delete_memory_failed'));
    },
  });

  const memories = data?.contact_memories ?? [];
  const total = data?.pagination?.total ?? memories.length;

  return {
    memories,
    total,
    status,
    error,
    deleteMemory: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending,
  };
};
